import { Grid } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import Calender from '../../components/Calender';
import SearchBar from './searchBar';
import InformationSection from './tickerInformationSection';
import { ToolTipElement } from './ToolTipElement';
import SecondTopTable from './topSecondTable';
import TopTable from './topTable';
import styles from './stockStyles';
import DropDownIcon from '../icons/drop.png';

const StockHeader = ({
  stockPageState,
  setStockPageState,
  fetchAll,
  FetchDependendonCalender,
}) => {
  const { isMobile, quoteInfo } = useSelector((state) => state.appReducer);

  return (
    <div>
      <Grid container spacing={0}>
        <Grid
          item
          xl={3}
          lg={3}
          md={3}
          sm={3}
          xs={6}
          style={
            isMobile
              ? { backgroundColor: '#D3D3D3' }
              : { backgroundColor: '#D3D3D3', height: '115px' }
          }
        >
          <div
            style={
              isMobile ? { justifyContent: 'center', marginTop: '5px' } : {}
            }
          >
            <div
              style={
                isMobile
                  ? { marginLeft: '5px', marginTop: '7px' }
                  : styles.SearchBar
              }
            >
              <SearchBar
                ticker={stockPageState.ticker}
                onChange={(value) =>
                  setStockPageState({ ...stockPageState, ticker: value })
                }
                setSymbolFunction={(value) =>
                  setStockPageState({ ...stockPageState, symbol: value })
                }
                fetchAll={fetchAll}
              />
            </div>
            <div
              style={
                isMobile
                  ? { marginLeft: '5px', marginTop: '5px' }
                  : styles.Calender
              }
            >
              <Calender
                value={stockPageState.date}
                disabled={stockPageState.symbol === '' ? true : false}
                getDate={(e) => {
                  FetchDependendonCalender(stockPageState.symbol, e);
                  setStockPageState({
                    ...stockPageState,
                    date: e,
                    modalDate: e,
                  });
                }}
              />
            </div>
          </div>
        </Grid>
        <Grid item xl={3} lg={3} md={3} sm={6} xs={6}>
          <InformationSection
            date={stockPageState.date}
            symbol={stockPageState.symbol}
            FetchDependendonCalender={FetchDependendonCalender}
          />
        </Grid>
        <Grid item xl={6} lg={6} md={6} sm={6} xs={12}>
          <div style={styles.TopTable}>
            <div>
              <TopTable
                tooltipClickHandler={() =>
                  setStockPageState({
                    ...stockPageState,
                    showModal: !stockPageState.showModal,
                    type: 'volume',
                  })
                }
              />
            </div>

            <div style={{ marginTop: '10px', marginLeft: '8px' }}>
              <SecondTopTable />
            </div>
          </div>
        </Grid>
      </Grid>
      <div style={{ display: 'flex', marginLeft: '1%' }}>
        {isMobile && (
          <div
            style={styles.dropDown3}
            onClick={() =>
              setStockPageState({
                ...stockPageState,
                table1Dropdown: !stockPageState.table1Dropdown,
              })
            }
          >
            <img height="15px" width="15px" src={DropDownIcon} alt="" />
          </div>
        )}
        <div style={isMobile ? styles.headingStyleMobile : styles.headingStyle}>
          Most Active {quoteInfo && quoteInfo.symbol} Strikes by Volume
        </div>
        <div style={{ marginTop: '2.2%', marginLeft: '1%' }}>
          <ToolTipElement
            clickHandler={() =>
              setStockPageState({
                ...stockPageState,
                showModal: !stockPageState.showModal,
                type: 'databox1',
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default StockHeader;



// WEBPACK FOOTER //
// ./src/Pages/Stock/StockHeader.jsx